import { render, staticRenderFns } from "./ThePersonAddressList.vue?vue&type=template&id=3ac3620a&"
import script from "./ThePersonAddressList.vue?vue&type=script&lang=js&"
export * from "./ThePersonAddressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports